<template>
  <div>
    <v-calendar
      class="custom-calendar mw-100"
      is-expanded
      :masks="masks"
      :attributes="availableDates"
      disable-page-swipe
    >
      <div
        slot="day-content"
        slot-scope="{ day, attributes }"
        class="d-flex flex-column h-100 z-10 overflow-auto"
      >
        <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
        <div class="flex-grow-1 overflow-none">
          <div
            v-for="attr in attributes"
            :key="attr.key"
            style="max-width: 140px; cursor: pointer"
            class="small rounded-sm p-1 mt-0 mb-1 overflow-auto"
            :class="attr.customData.class"
            @click="showBookings(attr)"
          >
            <div :style="styles.calendarItemWrapper">
              <div :style="styles.calendarItemTitle" v-html="attr.customData.title"></div>
              <div :style="styles.calendarItemCounter">{{`${attr.customData.participants - attr.customData.participants_left}`}}/{{attr.customData.participants}}</div>
            </div>
          </div>
        </div>
      </div>
    </v-calendar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { format, parseISO } from 'date-fns';
import { nb } from 'date-fns/locale';

export default {
  data() {
    return {
      masks: {
        weekdays: 'WWW',
      },

      styles: {
        calendarItemWrapper: 'position: relative;',
        calendarItemTitle:   `white-space: nowrap;
                              text-overflow: ellipsis;
                              max-width: 68%;
                              overflow: hidden;`,
        calendarItemCounter: `position: absolute;
                              top: -5px;
                              right: -5px;
                              padding: 5px;
                              color: #fff;
                              background-color: #9963cc;`
      }
    };
  },
  computed: {
    ...mapGetters({
      dates: 'bookings/availableDates',
      availableDates: 'bookings/calendarDates',
      availableDatesByDate: 'bookings/availableDatesByDate',
    }),
  },
  methods: {
    ...mapActions({
      getAvailableDates: 'bookings/getAvailableDates',
    }),
    showBookings(date) {
      this.$emit('show-bookings', date);
    }
  },
};
</script>

<style scoped>
.overflow-auto::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
